export const DEFAULT_STORE_KEY = 'initialReportValues';
export const ALL_TASKS_STORE_KEY = 'allTasks';